import emojiRegex from "emoji-regex";

const regexEmoji = emojiRegex();

/**
 * strip out the emojis
 * @param text
 */
export const stripEmojis = (text: string): string => {
	return text?.replace(regexEmoji, "")?.trim();
};